import { render, staticRenderFns } from "./NIC.vue?vue&type=template&id=6f887a85&scoped=true&"
import script from "./NIC.vue?vue&type=script&lang=js&"
export * from "./NIC.vue?vue&type=script&lang=js&"
import style0 from "./NIC.vue?vue&type=style&index=0&id=6f887a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f887a85",
  null
  
)

export default component.exports